import gql from 'graphql-tag';

export const getActivateConnectionId = gql`
  query GetActivateConnectionId {
    getActivateConnectionId {
      connectionId
      connection
      domainAlias
      organizationId
    }
  }
`;
